/**
 * [Pure] Send HTTP request and return response as promise.
 * @param verb - Method to use (get, post, put).
 * @param url - Endpoint to hit.
 * @param config - Configuration object { data }.
 */
export async function httpPromise(verb: string, url: string, config: any = {}): Promise<any> {
    let { data, params, contentType, headers, rejectHttpErrors } = config;                                       // Get data from config.
    const req = new XMLHttpRequest();                                                                           // Initialize http request object.
    if (params) { url += "?" + Object.keys(params).map(key => `${key}=${params[key]}`).join("&"); } // Add query parameters.
    if (url.endsWith("&")) { url = url.slice(0, -1); }                                             // Remove trailing "&".
    return new Promise((resolve, reject) => {                                                                   // Return promise (async).
        req.addEventListener("load", () => {
            let response: any = null;
            try { response = req.responseText ? JSON.parse(req.responseText) : null; }
            catch (e) { response = req.responseText || null; }
            if (rejectHttpErrors && (req.status < 200 || req.status >= 300)) {
                const error = Object.assign(
                    new Error(response?.detail || response?.message || response?.title || `Request failed with status ${req.status}.`),
                    { status: req.status, response }
                );
            reject(error instanceof Error ? error : new Error(String(error)));
                return;
            }
            resolve(response);
        });
        req.addEventListener("error", () => reject(new Error(`Request failed: ${verb} ${url}`)));
        req.addEventListener("abort", () => reject(new Error(`Request aborted: ${verb} ${url}`)));
        req.open(verb, url);                                                                                    // Open request.
        if (headers) { Object.keys(headers).forEach(key => req.setRequestHeader(key, headers[key])); }
        if (data) { req.setRequestHeader("Content-Type", contentType || "application/json;charset=UTF-8"); }       // If passing data, set requested content type.
        if (data && typeof data !== "string") { data = JSON.stringify(data); }                                      // If data isn't a string, stringify the payload.
        req.send(data || null);                                                                                 // Send request.
    });
}
